var map = {
	"./writingjapaneseanimal_100_audio.mp3": "FOYD",
	"./writingjapaneseanimal_10_audio.mp3": "vgsL",
	"./writingjapaneseanimal_11_audio.mp3": "SbZv",
	"./writingjapaneseanimal_12_audio.mp3": "HHHs",
	"./writingjapaneseanimal_13_audio.mp3": "Dw0h",
	"./writingjapaneseanimal_14_audio.mp3": "Hss7",
	"./writingjapaneseanimal_15_audio.mp3": "wYbX",
	"./writingjapaneseanimal_16_audio.mp3": "2ckh",
	"./writingjapaneseanimal_17_audio.mp3": "5hu/",
	"./writingjapaneseanimal_18_audio.mp3": "gay2",
	"./writingjapaneseanimal_19_audio.mp3": "zVSU",
	"./writingjapaneseanimal_1_audio.mp3": "vavC",
	"./writingjapaneseanimal_20_audio.mp3": "5hs5",
	"./writingjapaneseanimal_21_audio.mp3": "3rti",
	"./writingjapaneseanimal_22_audio.mp3": "U90G",
	"./writingjapaneseanimal_23_audio.mp3": "ls8a",
	"./writingjapaneseanimal_24_audio.mp3": "PkeN",
	"./writingjapaneseanimal_25_audio.mp3": "nBTp",
	"./writingjapaneseanimal_26_audio.mp3": "+qei",
	"./writingjapaneseanimal_27_audio.mp3": "Qpky",
	"./writingjapaneseanimal_28_audio.mp3": "hev7",
	"./writingjapaneseanimal_29_audio.mp3": "IS53",
	"./writingjapaneseanimal_2_audio.mp3": "m7Ht",
	"./writingjapaneseanimal_30_audio.mp3": "0e0R",
	"./writingjapaneseanimal_31_audio.mp3": "I9yn",
	"./writingjapaneseanimal_32_audio.mp3": "uN7u",
	"./writingjapaneseanimal_33_audio.mp3": "iYgg",
	"./writingjapaneseanimal_34_audio.mp3": "iGEb",
	"./writingjapaneseanimal_35_audio.mp3": "4t00",
	"./writingjapaneseanimal_36_audio.mp3": "zLqs",
	"./writingjapaneseanimal_37_audio.mp3": "TZfs",
	"./writingjapaneseanimal_38_audio.mp3": "Nryw",
	"./writingjapaneseanimal_39_audio.mp3": "iDnI",
	"./writingjapaneseanimal_3_audio.mp3": "wHYh",
	"./writingjapaneseanimal_40_audio.mp3": "gTMn",
	"./writingjapaneseanimal_41_audio.mp3": "MtlX",
	"./writingjapaneseanimal_42_audio.mp3": "Ss8W",
	"./writingjapaneseanimal_43_audio.mp3": "dQvM",
	"./writingjapaneseanimal_44_audio.mp3": "Oaoy",
	"./writingjapaneseanimal_45_audio.mp3": "RUqC",
	"./writingjapaneseanimal_46_audio.mp3": "+Wn1",
	"./writingjapaneseanimal_47_audio.mp3": "sgg3",
	"./writingjapaneseanimal_48_audio.mp3": "CXEd",
	"./writingjapaneseanimal_49_audio.mp3": "P2Zc",
	"./writingjapaneseanimal_4_audio.mp3": "HJyR",
	"./writingjapaneseanimal_50_audio.mp3": "Ifyy",
	"./writingjapaneseanimal_51_audio.mp3": "XNDr",
	"./writingjapaneseanimal_52_audio.mp3": "4Ids",
	"./writingjapaneseanimal_53_audio.mp3": "lu7E",
	"./writingjapaneseanimal_54_audio.mp3": "jifz",
	"./writingjapaneseanimal_55_audio.mp3": "UQxY",
	"./writingjapaneseanimal_56_audio.mp3": "9sge",
	"./writingjapaneseanimal_57_audio.mp3": "MXjx",
	"./writingjapaneseanimal_58_audio.mp3": "V1Ih",
	"./writingjapaneseanimal_59_audio.mp3": "e7Dv",
	"./writingjapaneseanimal_5_audio.mp3": "shCZ",
	"./writingjapaneseanimal_60_audio.mp3": "RImR",
	"./writingjapaneseanimal_61_audio.mp3": "HYq7",
	"./writingjapaneseanimal_62_audio.mp3": "mI1Q",
	"./writingjapaneseanimal_63_audio.mp3": "fhKK",
	"./writingjapaneseanimal_64_audio.mp3": "/ZKn",
	"./writingjapaneseanimal_65_audio.mp3": "AScx",
	"./writingjapaneseanimal_66_audio.mp3": "blg/",
	"./writingjapaneseanimal_67_audio.mp3": "UfzH",
	"./writingjapaneseanimal_68_audio.mp3": "Bop9",
	"./writingjapaneseanimal_69_audio.mp3": "nJaS",
	"./writingjapaneseanimal_6_audio.mp3": "b+6j",
	"./writingjapaneseanimal_70_audio.mp3": "FxWC",
	"./writingjapaneseanimal_71_audio.mp3": "3+F+",
	"./writingjapaneseanimal_72_audio.mp3": "kwd2",
	"./writingjapaneseanimal_73_audio.mp3": "MrUD",
	"./writingjapaneseanimal_74_audio.mp3": "TOUY",
	"./writingjapaneseanimal_75_audio.mp3": "02AH",
	"./writingjapaneseanimal_76_audio.mp3": "kuPc",
	"./writingjapaneseanimal_77_audio.mp3": "NYDy",
	"./writingjapaneseanimal_78_audio.mp3": "+RWU",
	"./writingjapaneseanimal_79_audio.mp3": "Fggy",
	"./writingjapaneseanimal_7_audio.mp3": "2NC0",
	"./writingjapaneseanimal_80_audio.mp3": "6r03",
	"./writingjapaneseanimal_81_audio.mp3": "nkRv",
	"./writingjapaneseanimal_82_audio.mp3": "zfn5",
	"./writingjapaneseanimal_83_audio.mp3": "eWy1",
	"./writingjapaneseanimal_84_audio.mp3": "rdct",
	"./writingjapaneseanimal_85_audio.mp3": "OwHx",
	"./writingjapaneseanimal_86_audio.mp3": "ysvk",
	"./writingjapaneseanimal_87_audio.mp3": "9Aua",
	"./writingjapaneseanimal_88_audio.mp3": "AK6Y",
	"./writingjapaneseanimal_89_audio.mp3": "tPc4",
	"./writingjapaneseanimal_8_audio.mp3": "QpiR",
	"./writingjapaneseanimal_90_audio.mp3": "YWVo",
	"./writingjapaneseanimal_91_audio.mp3": "hQTG",
	"./writingjapaneseanimal_92_audio.mp3": "J1Ke",
	"./writingjapaneseanimal_93_audio.mp3": "ynkM",
	"./writingjapaneseanimal_94_audio.mp3": "IEJx",
	"./writingjapaneseanimal_95_audio.mp3": "g8KS",
	"./writingjapaneseanimal_96_audio.mp3": "sBxL",
	"./writingjapaneseanimal_97_audio.mp3": "nu5j",
	"./writingjapaneseanimal_98_audio.mp3": "CieJ",
	"./writingjapaneseanimal_99_audio.mp3": "NuCw",
	"./writingjapaneseanimal_9_audio.mp3": "cQzk",
	"./writingjapaneseanimal_title_audio.mp3": "Dd4l"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rKIT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/audio ^\.\/writingjapaneseanimal_.*_audio\.mp3$
// module id = rKIT
// module chunks = 0